<div>
    <div class="font-bold text-xl mb-4">Lista wallet</div>
    
    <div class="grid grid-cols-4 gap-4 mb-4">
        <div class="font-bold col-span-3">Grand Total</div>
        <div class="font-bold text-right">{{grandTotal()| currency:'EUR'}}</div>

        <div class="font-bold col-span-2">Descrizione</div>
        <div class="text-right font-bold">Liquidità</div>
        <div class="text-right font-bold">Investimento</div>
        @for (item of wallets(); track $index) {
            <div class="col-span-2 cursor-pointer" (click)="onSelect.emit(item)">{{walletStoreService.findReactive(item.finWalletId)()?.shortDescription }}</div>
            <div class="text-right">{{item.liquidityAmount | currency:'EUR'}}</div>
            <div class="text-right">{{item.investmentAmount | currency:'EUR'}}</div>
        }
        <div class="font-bold col-span-2">Totale</div>
        <div class="text-right font-bold">{{total().liquidityAmount | currency:'EUR'}}</div>
        <div class="text-right font-bold">{{total().investmentAmount | currency:'EUR'}}</div>
    </div>
</div>